
import CommonPopup from "@/components/CommonPopup.vue";
import { CommonImagesVO } from "@/views/biz/review/vo/file.vo";
import { Swiper } from "swiper/js/swiper.esm";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class CommonImageViewer extends CommonPopup {
  @Prop()
  images!: Array<CommonImagesVO>;

  // 비디오플레이어 옵션
  playerOptionsDefault = {
    muted: true,
    playsinline: true,
    language: "en",
    controls: true,
    playbackRates: [0.7, 1.0, 1.5, 2.0], //재생속도
  };

  // 상품 이미지 swiper
  swiperReviewImg: Swiper;
  swiperReviewImgOptions = {
    slidesPerView: 1,
    lazy: { loadOnTransitionStart: true },
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
    },
  };

  // methods

  // 비디오플레이어 옵션
  getPlayerOptions(options: any) {
    return Object.assign(this.playerOptionsDefault, options);
  }
}
